import React, {Component} from "react";
import PropTypes from "prop-types";

import {cloneDeep, remove} from "lodash";

import {
    Input,
} from "reactstrap";

// Helper functions
import formatElement from "classes/FormatElement.jsx";

// Third-party signature plugin
import SignatureCanvas from 'react-signature-canvas'

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons';

class SignatureField extends Component {
    
    debug = false;
    state = {
        newSignature: null,
        cleared: false,
        isChanged: false
    };
    signaturePad = null
    
    constructor( props ){
        super( props );
        
        this.signaturePad = React.createRef();
    }
    
    componentDidMount() {
        const { value } = this.props;
        // if( '' != value ){
        //     fromDataURL
        // }
    }
    
    componentDidUpdate( prevProps ) {
        const oldValue = prevProps.value;
        const oldisVisible = prevProps.isVisible;
        const { isVisible, value } = this.props;
        const { newSignature } = this.state;
        
        if( isVisible && !oldisVisible ){
            if( this.signaturePad.current && null != newSignature ){
                if( this.debug ) console.log('Importing signature from state');
                this.signaturePad.current.clear();
                this.signaturePad.current.fromData( newSignature );
            }
        }
        
        if( oldValue != value ){
            this.setState({cleared:false});
        }
    }
    
    handleSignatureEnd = (e) => {
        if(this.debug) console.log('Signature end');
        // Get signature as base64 image
        const sigImage = this.signaturePad.current.getTrimmedCanvas().toDataURL( 'image/png' );
        this.trigger_change( sigImage );
        const sigData = this.signaturePad.current.toData();
        
        this.setState({newSignature: sigData});
    };
    
    trigger_change = ( newValue ) => {
        const { onChange } = this.props;
        if(this.debug) console.log('Signature changed to: ', newValue);
        // call onChange() with base64 image
        onChange( JSON.stringify(newValue) );
    };
    
    clearSignature = () => {
        if( this.debug ) console.log('Signature cleared');
        if( this.signaturePad.current ){
            this.signaturePad.current.clear();
        }
        
        this.setState({cleared:true, isChanged:false});
    };
    
    render(){
        const {
            fldId,
            value,
            terms,
            onChange,
            isVisible,
            error,
            readonly,
            className,
            logicFn,
            templateFn
        } = this.props;
        
        const { cleared, isChanged } = this.state;
        
        let fldClass = className+' signatureField';
        if( error ){
            fldClass += ' fld-error';
            if(this.debug) console.log('SIGNATURE ERROR!!!!!!!', fldId);
        }
        
        let termsConditions = [];
        let count = 0;
        terms.map((elm) => {
            termsConditions.push( formatElement(elm, count, logicFn, templateFn) );
            count++;
        });
        if(this.debug) console.log('Terms: ', terms);
        if(this.debug) console.log('Signature field visibility: ', isVisible);
        
        // Make field read only once it's been filled out.
        let hasExValue = false;
        let exValue = value;
        let signedDate = '';
        if( value.startsWith('{') && !cleared ){
            hasExValue = true;
            try {
                if( this.debug ) console.log('Signature JSON: ',value.replace(/\\(.)/mg, "$1"));
                let exValueJson = JSON.parse(value.replace(/\\(.)/mg, "$1"));
                signedDate = exValueJson.signed;
                exValue = exValueJson.url;
            } catch (e) {
                console.log('Error parsing exising signature value JSON.');
                hasExValue = false;
            }
        } else if( value.startsWith('http') && !cleared ){
            hasExValue = true;
        }
        
        if( '' != signedDate ){
            const signed = new Date( signedDate );
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            signedDate = signed.toLocaleDateString('en-AU', options);
        }
        
        return (
            <>
                <div className="signatureTerms">
                    {termsConditions}
                </div>
                <div className={fldClass} id={"signature-"+fldId}>
                    {(readonly||hasExValue)?(
                        <>
                        <img className="signaturePreview" src={exValue} />
                        <span className="signatureDate">{signedDate}</span>
                        </>
                    ):(
                        <>
                        {isVisible?(
                            <>
                            <SignatureCanvas
                                ref={this.signaturePad}
                                canvasProps={{className: "signaturePad"}}
                                onEnd={this.handleSignatureEnd}
                                onBegin={()=>{
                                    if( this.debug ) console.log('Signature begin');
                                    this.setState({isChanged:true});
                                }}
                            />
                            {(!isChanged)?(
                                <div className="signature_placeholder">Please Sign Here</div>
                            ):null}
                            </>
                        ):(null)}
                        </>
                    )}
                    {(!readonly)?(
                        <div
                            className="clearBtn"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearSignature();
                            }}
                        >
                            <FontAwesomeIcon className="menuIcon" icon={faTrashUndo} />
                        </div>
                    ):null}
                </div>
            </>
        );
    }
}

SignatureField.propTypes = {
    fldId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    terms: PropTypes.array,
    isVisible: PropTypes.bool,
    error: PropTypes.bool,
    readonly: PropTypes.bool,
    onChange: PropTypes.func,
    logicFn: PropTypes.func,
    templateFn: PropTypes.func,
    className: PropTypes.string,
};

SignatureField.defaultProps = {
    fldId: null,
    value: null,
    terms: [],
    isVisible: false,
    error: false,
    readonly: false,
    onChange: (newVal) => {console.log('SignatureField value updated',newVal)},
    logicFn: (conditions) => {return true;},
    templateFn: (match, fld) => {console.log('templateFn',match,fld);return match;},
    className: "",
}

export default SignatureField;
